/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './emitEvent.defs.js'
export { main as default } from './emitEvent.defs.js'
